<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
  </div>
  <div class="row">
    <!-- SELECT TYPE DEAL -->
    <section class="col-12">
      <div class="card" [formGroup]="formGroupDetail">
        <!--TITLE-->
        <div class="card-title px-2 pt-2 mb-0 d-flex align-items-center">
          <h3 class="mr-075 mb-0">{{ "DETAIL_COMMISSION" | translate }}</h3>
          <span class="badge badge-info" *ngIf="formGroupDetail.value.detachment">{{ "DETACHMENT" | translate }}</span>
        </div>
        <div class="card-body pb-0">
          <!--TYPE_SELECTION-->
          <div class="row">
            <div class="form-group col-xl-4 col-12">
              <label>{{ "CUSTOMER" | translate }}<sup class="text-danger">*</sup></label>
              <ng-select bindLabel="name" bindValue="id" formControlName="customer" [multiple]="false" [searchable]="true" [closeOnSelect]="true" [readonly]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" [items]="customersList"></ng-select>
            </div>
            <div class="form-group col-xl-2 col-12">
              <label>{{ "PROTOCOL" | translate }}<sup class="text-danger">*</sup></label>
              <input class="form-control" [(ngModel)]="currentCommission.protocol" [ngModelOptions]="{ standalone: true }" [readonly]="true" />
            </div>
            <div class="form-group col-xl-6 col-12">
              <label>{{ "NAME" | translate }}<sup class="text-danger">*</sup></label>
              <input class="form-control" formControlName="name" [placeholder]="'PLACEHOLDER.INSERT_NAME' | translate" />
              <div class="invalid-feedback">{{ "ERRORS.FIELD_NAME" | translate }}</div>
            </div>
            <div class="col-12">
              <label class="mr-075">{{ "CREATON_DATE" | translate }}: </label>
              <span>{{ currentCommission.create_date | date: 'dd/MM/yyyy' }}</span>
            </div>
            <div class="form-group col-12">
              <label class="mr-075">{{ "STATE_COMMISSION" | translate }}: </label>
              <div class="badge badge-pill badge-{{ currentCommission.status === 0 ? 'success' : 'danger' }}">
                {{ currentCommission.status === 0 ? ("OPENED_FEMALE" | translate) : isClosingCommission(currentCommission.closed_date) ? ("CLOSING" | translate) : ("CLOSED_FEMALE" | translate) }}
              </div>
            </div>
            <div class="col-12" *ngIf="!!currentCommission.closed_date && currentCommission.status === 1">
              <label class="mr-075">{{ "DATE" | translate }}: </label>
              <span>{{ currentCommission.closed_date | date: 'dd/MM/yyyy' }}</span>
            </div>
            <div class="col-12" *ngIf="!!currentCommission.status_note && currentCommission.status === 1">
              <label class="mr-075">{{ "NOTE" | translate }}: </label>
              <span>{{ currentCommission.status_note }}</span>
            </div>
          </div>
        </div>
        <div class="card-footer col-12 d-flex justify-content-between border-0">
          <button class="btn btn-outline-primary mr-1" has_capability="edit_commission" (click)="modalOpen(closeCommissionModal, null)" *ngIf="currentCommission.status === 0">
            {{ "CLOSE_COMMISSION" | translate }}
          </button>
          <button class="btn btn-outline-primary mr-1" has_capability="edit_commission" (click)="reOpenCommission()" *ngIf="currentCommission.status === 1">{{ "REOPEN_COMMISSION" | translate }}</button>
          <button class="btn btn-primary" has_capability="edit_commission" (click)="editCommission()" *ngIf="!currentCommission.closed">{{ "EDIT_NAME" | translate }}</button>
        </div>
      </div>
    </section>
    <!--ADMINISTRATIVE DETAIL SECTION-->
    <section class="col-12 section">
      <div class="card" [ngClass]="activeTab === 'orders' ? 'active pb-0' : ''">
        <!--TITLE-->
        <div class="card-title px-2 mb-0" (click)="changeTab('orders')">
          <h3>{{ "ADMINISTRATIVE_DETAIL" | translate }}</h3>
        </div>
        <div [ngClass]="activeTab === 'orders' ? 'card-body p-0' : 'd-none'" *ngIf="_utilService.isDesktop">
          <div class="row px-2 mb-1">
            <div class="col-12 text-right" has_capability="create_order" *ngIf="!currentCommission.closed">
              <button class="btn btn-outline-primary" (click)="modalOpen(detailOrder, null)">{{ "ADD_ROUND" | translate }}</button>
            </div>
          </div>
          <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="30" [scrollbarH]="true" [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
                         *ngIf="orderList && orderList.length > 0" [rowClass]="getRowClass" [rowHeight]="60" [limit]="10" [footerHeight]="50" [rows]="orderList" [sorts]="[{ prop: 'progressive_id', dir: 'desc' }]">
            <ngx-datatable-column [name]="'ROUND' | translate" [sortable]="false" [resizeable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span class="font-weight-bold">{{ row.progressive_id ? row.progressive_id : "-" }} {{ row.detachment_type ? "- " + row.detachment_type : null }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'STATE' | translate" [sortable]="false" [resizeable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span class="badge badge-pill badge-{{ row?.status_order.color }}">{{ row?.status_order.label | translate }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'TITLES.USERS_TYPES.employee' | translate" [sortable]="false" [resizeable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span class="text-break-line-1" [ngbTooltip]="row.employees_names ? row.employees_names : null">{{ row.employees_names ? row.employees_names.join(', ') : "-" }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'FROM' | translate" [sortable]="false" [resizeable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.from ? (row.from | date: 'dd/MM/yyyy') : "-" }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'TO' | translate" [sortable]="false" [resizeable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span *ngIf="row.closed" [ngbTooltip]="('ORIGINAL_END_DATE' | translate) + ': ' + (row.to | date: 'dd/MM/yyyy')">{{ row.status_order.closed_date }}</span>
                <span *ngIf="!row.closed">{{ row.to | date: 'dd/MM/yyyy' }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'RESIDUE' | translate" [sortable]="false" [resizeable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ !row.detachment_type || row.detachment_type !== "distacco" ? ((row.total_residue ? row.total_residue : 0) | currency: 'EUR') : "-" }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'ACTIONS' | translate" [sortable]="false" [resizeable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex">
                  <ng-container *ngIf="!row.detachment_type || row.detachment_type !== 'delta'">
                    <button class="bg-transparent border-0 text-secondary pr-1" [ngbTooltip]="'DUPLICATE_ROUND' | translate">
                    <span (click)="duplicateOrder(row.deal_id)" class="text-secondary text-center">
                      <i [data-feather]="'copy'" size="19"></i>
                    </span>
                    </button>
                    <button class="bg-transparent border-0 text-secondary pr-1">
                    <span (click)="modalOpen(detailOrder, row)" class="text-secondary text-center" [ngbTooltip]="'EDIT' | translate" placement="left">
                      <i [data-feather]="'edit-2'" size="19"></i>
                    </span>
                    </button>
                  </ng-container>
                  <button *ngIf="!row.detachment_type || (row.detachment_type !== 'delta' && !currentCommission.closed)" class="bg-transparent border-0 text-secondary pr-1">
                    <span (click)="deleteOrder(row.order_id)" class="text-danger text-center" [ngbTooltip]="'DELETE' | translate" placement="left">
                      <i [data-feather]="'trash-2'" size="19"></i>
                    </span>
                  </button>
                  <button *ngIf="(!row.detachment_type || row.detachment_type !== 'delta') && !row.closed && !currentCommission.closed" class="bg-transparent border-0 text-secondary">
                    <span (click)="openModalCloseRound(closeRoundModal, row)" class="text-danger text-center" [ngbTooltip]="'CLOSE_ROUND' | translate" placement="left">
                      <i [data-feather]="'lock'" size="19"></i>
                    </span>
                  </button>
                  <!--                  <button *ngIf="(!row.detachment_type || row.detachment_type !== 'delta') && !!row.closed && !currentCommission.closed" class="bg-transparent border-0 text-secondary">-->
                  <!--                    <span (click)="openModalCloseRound(closeRoundModal, row)" class="text-success text-center" [ngbTooltip]="'OPEN_ROUND' | translate" placement="left">-->
                  <!--                      <i [data-feather]="'unlock'" size="19"></i>-->
                  <!--                    </span>-->
                  <!--                  </button>-->
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
        <div [ngClass]="activeTab === 'orders' ? 'card-body pb-0 px-0' : 'd-none'" *ngIf="!_utilService.isDesktop">
          <div class="row" has_capability="create_order">
            <div class="col-12 text-center mb-1">
              <button class="btn btn-outline-primary" (click)="modalOpen(detailOrder, null)">{{ "ADD_ROUND" | translate }}</button>
            </div>
          </div>
          <ngx-datatable
            class="bootstrap core-bootstrap"
            columnMode="force"
            [headerHeight]="30"
            [scrollbarH]="true"
            [rowClass]="getRowClass"
            [rowHeight]="250"
            [limit]="10"
            [footerHeight]="0"
            [rows]="orderList"
            *ngIf="orderList && orderList.length > 0"
            [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
            [sorts]="[{ prop: 'progressive_id', dir: 'desc' }]"
          >
            <ngx-datatable-column [name]="'ROUND' | translate" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="row">
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "ROUND" | translate }}: </span>
                    <span>{{ row.progressive_id ? row.progressive_id : "-" }} {{ row.detachment_type ? row.detachment_type : null }}</span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "STATE" | translate }}: </span>
                    <span class="badge badge-pill badge-{{ row?.status_order.color }}" [ngbTooltip]="row?.status_order?.closed_date ? row?.status_order?.closed_date : null">
                      {{ row?.status_order.label | translate }}
                    </span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "TITLES.USERS_TYPES.employee" | translate }}: </span>
                    <span class="text-break-line-1" [ngbTooltip]="row.employees_names ? row.employees_names : null">{{ row.employees_names ? row.employees_names : "-" }}</span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "FROM" | translate }}: </span>
                    <span>{{ row.from ? (row.from | date: 'dd/MM/yyyy') : "-" }}</span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "TO" | translate }}: </span>
                    <span>{{ row.status_order?.closed_date ? row?.status_order?.closed_date : row.to | date: 'dd/MM/YYYY' }}</span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "RESIDUE" | translate }}: </span>
                    <span>{{ !row.detachment_type || row.detachment_type !== "distacco" ? (row.total_residue | currency: 'EUR') : "-" }}</span>
                  </div>
                  <div class="col-12 d-flex justify-content-end" *ngIf="isDetachment(row)">
                    <button class="bg-transparent border-0 text-secondary pr-1">
                      <span (click)="modalOpen(detailOrder, row)" class="text-secondary text-center">
                        <i [data-feather]="'edit-2'" size="19"></i>
                      </span>
                    </button>
                    <ng-container *ngIf="!currentCommission.closed">
                      <button class="bg-transparent border-0 text-danger text-center pr-1" (click)="deleteOrder(row.order_id)" [ngbTooltip]="'DELETE_ROUND' | translate">
                        <i [data-feather]="'trash-2'" size="19"></i>
                      </button>
                      <button *ngIf="row.closed" class="bg-transparent border-0 text-danger text-center" (click)="openModalCloseRound(closeRoundModal, row)">
                        <i [data-feather]="'lock'" size="19"></i>
                      </button>
                      <button *ngIf="!row.closed" class="bg-transparent border-0 text-success text-center" (click)="openModalCloseRound(closeRoundModal, row)">
                        <i [data-feather]="'unlock'" size="19"></i>
                      </button>
                    </ng-container>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </div>
    </section>
    <!--ECONOMIC DETAIL SECTION-->
    <section class="col-12 section" has_capability="show_commission_economics" *ngIf="economicList && economicList.length > 0">
      <!--Desktop Economic-->
      <div class="card" [ngClass]="activeTab === 'economic' ? 'active' : ''" *ngIf="_utilService.isDesktop">
        <!--TITLE-->
        <div class="card-title px-2 mb-0" (click)="changeTab('economic')">
          <h3>{{ "ECONOMIC_DETAIL" | translate }}</h3>
        </div>
        <div [ngClass]="activeTab === 'economic' ? 'card-body p-0 pt-1' : 'd-none'">
          <div class="row px-2">
            <div class="col-xl-8 pb-2">
              <strong>{{ 'REGENERATE_ANALYTICS' | translate }}</strong>
              <p class="font-small-3 mb-05">{{ 'REGENERATE_MONTLY_AND_YEARLY_ANALYTICS' | translate }}</p>
              <div class="d-flex align-items-center">
                <ng-select [style.width.em]="10" [(ngModel)]="regenerateMonth" [searchable]="false" [closeOnSelect]="true" [openOnEnter]="true" [clearable]="false">
                  <ng-option *ngFor="let month of monthsList; let i = index" [value]="i+1">{{ month | titlecase }}</ng-option>
                </ng-select>
                <ng-select [style.width.em]="10" class="mx-1" [(ngModel)]="regenerateYear" [searchable]="false" [closeOnSelect]="true" [openOnEnter]="true" [clearable]="false">
                  <ng-option *ngFor="let year of analyticsYears" [value]="year">
                    <span class="pr-4">{{ year }}</span>
                  </ng-option>
                </ng-select>
                <button class="btn btn-outline-primary" (click)="regenerateAnalytics()">{{ 'REGENERATE' | translate }}</button>
              </div>
            </div>
            <div class="col-xl-4 text-right pb-2">
              <strong class="d-block font-small-3 mb-05">{{ "FILTER_BY_YEAR" | translate }}</strong>
              <select class="form-control d-inline-block w-fit ml-1 pr-4" [(ngModel)]="filterAnalyticsYear" (change)="loadCommission()">
                <option *ngFor="let year of analyticsYears" [selected]="year === filterAnalyticsYear" [value]="year">{{ year }}</option>
              </select>
            </div>
          </div>
          <div class="d-flex p-1 data-header">
            <div class="flex-basis-5"></div>
            <div class="flex-basis-5">
              {{ "MONTH" | translate | uppercase }}
            </div>
            <div class="flex-basis-5">
              {{ "ROUND" | translate | uppercase }}
            </div>
            <div class="flex-basis-10">
              {{ "ESTIMATED_COST" | translate | uppercase }}
            </div>
            <div class="flex-basis-10">
              {{ "EFFECTIVE_COST" | translate | uppercase }}
            </div>
            <div class="flex-basis-10">
              {{ "PROVIDER_COST" | translate | uppercase }}
            </div>
            <div class="flex-basis-15">
              {{ "ESTIMATED_REVENUE" | translate | uppercase }}
            </div>
            <div class="flex-basis-15">
              {{ "EFFECTIVE_REVENUE" | translate | uppercase }}
            </div>
            <div class="flex-basis-10">
              {{ "EURO_MARGIN" | translate | uppercase }}
            </div>
            <div class="flex-basis-10">
              {{ "PERCENTAGE_MARGIN" | translate | uppercase }}
            </div>
          </div>
          <div class="mx-0 data-row pl-0 cursor-pointer border-bottom {{ row.classStyle === 'grey' ? 'bg-light-secondary' : null }}" *ngFor="let row of economicList; let i = index">
            <div class="row px-1">
              <div class="flex-basis-5 text-center" [ngbTooltip]="'OPEN_DETAIL' | translate" (click)="openEconomicDetail(i)">
                <i size="14" [data-feather]="'eye'"></i>
              </div>
              <div class="flex-basis-5 font-weight-bold">{{ row.month ? row.month : "-" }}</div>
              <div class="flex-basis-5">
                <span class="font-weight-bold">{{ row.progressive_id ? row.progressive_id : "-" }} {{ row.detachment_type ? "- " + row.detachment_type : null }}</span>
              </div>
              <div class="flex-basis-10">{{ row.estimated_cost ? row.estimated_cost : "0,00" }} €</div>
              <div class="flex-basis-10 text-{{ row.effective_cost_color }}">{{ row.effective_cost ? row.effective_cost : "-0,00" }} €</div>
              <div class="flex-basis-10">{{ row.provider_cost ? row.provider_cost : "0,00" }} €</div>
              <div class="flex-basis-15">{{ row.estimated_revenue ? row.estimated_revenue : "0,00" }} €</div>
              <div class="flex-basis-15 text-{{ row.effective_revenue_color }}">{{ row.effective_revenue ? row.effective_revenue : "0,00" }} €</div>
              <div class="flex-basis-10">{{ row.euro_margin ? row.euro_margin : "0,00" }} €</div>
              <div class="flex-basis-10 text-{{ row.margin_color }}">{{ row.percentage_margin ? _utilService.addDotsToNumber(row.percentage_margin) : "0" }} %</div>
              <div class="flex-basis-3 text-center ml-05" [ngbTooltip]="'REFRESH_ANALYTIC' | translate" (click)="reloadCommissionEconomic(row.order_number, row.month_value, row.year_value, row.employee_details)">
                <i size="14" [data-feather]="'refresh-cw'" class="text-primary"></i>
              </div>
            </div>
            <!--Detail for each employee-->
            <div class="col-12 px-0" *ngIf="row.open_modal">
              <div class="d-flex p-0 border-bottom detail-row-datatable">
                <div class="flex-basis-15 ml-2 d-flex align-items-center"></div>
                <div class="flex-basis-15 font-small-1">{{ "ESTIMATED_COST" | translate | uppercase }}</div>
                <div class="flex-basis-15 font-small-1">{{ "EFFECTIVE_COST" | translate | uppercase }}</div>
                <div class="flex-basis-15 font-small-1">{{ "ESTIMATED_REVENUE" | translate | uppercase }}</div>
                <div class="flex-basis-15 font-small-1">{{ "EFFECTIVE_REVENUE" | translate | uppercase }}</div>
                <div class="flex-basis-10 font-small-1">{{ "EURO_MARGIN" | translate | uppercase }}</div>
                <div class="flex-basis-10 font-small-1">{{ "PERCENTAGE_MARGIN" | translate | uppercase }}</div>
              </div>
              <div class="d-flex p-0 pt-05 pb-05 border-bottom detail-row-datatable" *ngFor="let emp of row.employee_details">
                <div class="flex-basis-15 ml-2 d-flex align-items-center">
                  <ng-container [ngSwitch]="emp.type_code">
                    <a *ngSwitchCase="'product'" [ngbTooltip]="'PRODUCT' | translate" [routerLink]="'/dashboard/product/' + emp.id" target="_blank">{{ emp.name || "-" }}</a>
                    <a *ngSwitchCase="'employee'" [ngbTooltip]="'EMPLOYEE' | translate" [routerLink]="'/dashboard/user/profile/' + emp.employee_hash" target="_blank">{{ emp.employee_name || "-" }}</a>
                    <a *ngSwitchCase="'ex-employee'" [ngbTooltip]="'Ex' + ('EMPLOYEE' | translate)" [routerLink]="'/dashboard/user/profile/' + emp.employee_hash" target="_blank">{{ emp.employee_name || "-" }}</a>
                    <a *ngSwitchCase="'future-employee'" [ngbTooltip]="'FUTURE_EMPLOYEE' | translate" [routerLink]="'/dashboard/future-employee/profile/' + emp.employee_hash" target="_blank">{{ emp.employee_name || "-" }}</a>
                    <a *ngSwitchCase="'candidate'" [ngbTooltip]="'CANDIDATE' | translate" [routerLink]="'/dashboard/candidate/edit/' + emp.employee_hash" target="_blank">{{ emp.employee_name || "-" }}</a>
                    <a *ngSwitchDefault [ngbTooltip]="'COLLABORATOR' | translate" [routerLink]="'/dashboard/collaborators/edit/' + emp.employee_hash" target="_blank">{{ emp.employee_name || "-" }}</a>
                  </ng-container>
                  <span *ngIf="emp.commissions_number && emp.commissions_number > 1" class="commission-number" [ngbTooltip]="('COMMISSIONS_NUMBER' | translate) + ' ' + emp.commissions_number">{{ emp.commissions_number }}</span>
                </div>
                <div class="flex-basis-15">
                  <span placement="right" [ngbTooltip]="costTooltip(row.order_type, 'estimated_cost', emp, row)">{{ emp.estimated_cost ? emp.estimated_cost : "0,00" }} €</span>
                </div>
                <div class="flex-basis-15">{{ emp.real_cost | currency: "EUR" }}</div>
                <div class="flex-basis-15">
                  <span placement="right" [ngbTooltip]="costTooltip(row.order_type, 'estimated_revenue', emp, row)">{{ emp.estimated_revenue ? emp.estimated_revenue : "0,00" }} €</span>
                </div>
                <div class="flex-basis-15">
                  <span placement="right" [ngbTooltip]="costTooltip(row.order_type, 'real_profit', emp, row)">{{ emp.real_profit | currency: "EUR" }}</span>
                </div>
                <div class="flex-basis-10">{{ (emp.euro_margin || '0') | currency: "EUR" }}</div>
                <div class="flex-basis-5">{{ _utilService.addDotsToNumber(emp.percentage_margin) }} %</div>
              </div>
            </div>
          </div>
          <div class="row data-row">
            <div class="flex-basis-15 text-center font-weight-bold">{{ "TOTAL" | translate }}:</div>
            <div class="flex-basis-10">
              <span class="font-weight-bold">{{ total_estimated_cost }} €</span>
            </div>
            <div class="flex-basis-10">
              <span class="font-weight-bold">{{ total_real_cost }} €</span>
            </div>
            <div class="flex-basis-10">
              <span class="font-weight-bold">{{ total_provider_cost }} €</span>
            </div>
            <div class="flex-basis-15">
              <span class="font-weight-bold">{{ total_estimated_revenue }} €</span>
            </div>
            <div class="flex-basis-15">
              <span class="font-weight-bold">{{ total_real_profit }} €</span>
            </div>
            <div class="flex-basis-10">
              <span class="font-weight-bold">{{ total_margin_euro }} €</span>
            </div>
            <div class="flex-basis-10">
              <span class="font-weight-bold">{{ total_margin_percentage }} %</span>
            </div>
          </div>
        </div>
      </div>
      <!--Mobile Economic-->
      <div class="card" [ngClass]="activeTab === 'economic' ? 'active' : ''" *ngIf="!_utilService.isDesktop">
        <!--TITLE-->
        <div class="card-title px-2 mb-0" (click)="changeTab('economic')">
          <h3>{{ "ECONOMIC_DETAIL" | translate }}</h3>
        </div>
        <div [ngClass]="activeTab === 'economic' ? 'card-body pb-0 px-0' : 'd-none'">
          <div class="col-12 p-1 data-header">
            {{ "MONTH" | translate | uppercase }}
          </div>
          <div class="row pt-1 mx-0 border-bottom" *ngFor="let row of economicList; let i = index" [ngClass]="{ 'bg-light-secondary': row.classStyle == 'grey' }">
            <div class="col-12">
              <span class="font-weight-bold">{{ "MONTH" | translate | titlecase }}: </span>
              <span>{{ row.month ? row.month : "-" }}</span>
            </div>
            <div class="col-12">
              <span class="font-weight-bold">{{ "ROUND" | translate }}: </span>
              <span>{{ row.progressive_id ? row.progressive_id : "-" }} {{ row.detachment_type ? "- " + row.detachment_type : null }}</span>
            </div>
            <div class="col-12">
              <span class="font-weight-bold">{{ "ESTIMATED_COST" | translate }}: </span>
              <span>{{ row.estimated_cost ? row.estimated_cost : "0,00" }} €</span>
            </div>
            <div class="col-12">
              <span class="font-weight-bold">{{ "EFFECTIVE_COST" | translate }}: </span>
              <span>{{ row.real_cost ? row.real_cost : "0,00" }} €</span>
            </div>
            <div class="col-12">
              <span class="font-weight-bold">{{ "PROVIDER_COST" | translate }}: </span>
              <span>{{ row.provider_cost ? row.provider_cost : "0,00" }} €</span>
            </div>
            <div class="col-12">
              <span class="font-weight-bold">{{ "ESTIMATED_REVENUE" | translate }}: </span>
              <span>{{ row.estimated_revenue ? row.estimated_revenue : "0,00" }} €</span>
            </div>
            <div class="col-12">
              <span class="font-weight-bold">{{ "EFFECTIVE_REVENUE" | translate }}: </span>
              <span>{{ row.real_profit ? row.real_profit : "0,00" }} €</span>
            </div>
            <div class="col-12">
              <span class="font-weight-bold">{{ "EURO_MARGIN" | translate }}: </span>
              <span>{{ row.euro_margin ? row.euro_margin : "0,00" }} €</span>
            </div>
            <div class="col-12">
              <span class="font-weight-bold">{{ "PERCENTAGE_MARGIN" | translate }}: </span>
              <span>{{ row.percentage_margin ? row.percentage_margin : "0" }} %</span>
            </div>
            <div class="col-12 text-center mt-1" [ngClass]="row.open_modal ? '' : 'mb-1'">
              <button (click)="openEconomicDetail(i)" class="btn btn-sm btn-outline-primary">{{ (row.open_modal ? "CLOSE_DETAIL" : "OPEN_DETAIL") | translate }}</button>
              <button (click)="reloadCommissionEconomic(row.order_number, row.month_value, row.year_value, row.employee_details)" has_capability="create_commission_analytics_monthly" class="btn btn-sm btn-outline-primary ml-5">
                {{ "REGENERATE_CALCULATE_ECONOMIC" | translate }}
              </button>
            </div>
            <!--Detail for each employee-->
            <div class="mt-1 w-100 border-top" *ngIf="row.open_modal">
              <div class="py-1 px-0 detail-row-datatable" *ngFor="let emp of row.employee_details; let i = index" [ngClass]="i < row.employee_details.length - 1 ? 'border-bottom' : ''">
                <div class="col-12 d-flex align-items-center">
                  <span class="font-weight-bold">{{ "TITLES.USERS_TYPES_SINGULAR.employee" | translate }}:&nbsp;</span>
                  <ng-container [ngSwitch]="emp.type_code">
                    <a *ngSwitchCase="'employee'" [ngbTooltip]="'EMPLOYEE' | translate" [routerLink]="'/dashboard/user/profile/' + emp.employee_hash" target="_blank">{{ emp.employee_name || "-" }}</a>
                    <a *ngSwitchCase="'ex-employee'" [ngbTooltip]="'USERS_TYPES_SINGULAR.ex-employee' | translate" [routerLink]="'/dashboard/user/profile/' + emp.employee_hash" target="_blank">{{
                        emp.employee_name || "-"
                      }}</a>
                    <a *ngSwitchCase="'future-employee'" [ngbTooltip]="'FUTURE_EMPLOYEE' | translate" [routerLink]="'/dashboard/future-employee/profile/' + emp.employee_hash" target="_blank">{{
                        emp.employee_name || "-"
                      }}</a>
                    <a *ngSwitchCase="'candidate'" [ngbTooltip]="'CANDIDATE' | translate" [routerLink]="'/dashboard/candidate/edit/' + emp.employee_hash" target="_blank">{{ emp.employee_name || "-" }}</a>
                    <a *ngSwitchDefault [ngbTooltip]="'COLLABORATOR' | translate" [routerLink]="'/dashboard/collaborators/edit/' + emp.employee_hash" target="_blank">{{ emp.employee_name || "-" }}</a>
                  </ng-container>
                  <span
                    class="commission-number"
                    *ngIf="emp.commissions_number && emp.commissions_number > 1"
                    [ngbTooltip]="('EMPLOYEEE_HAS_COMMISSION_NUMBER' | translate) + emp.commissions_number + ('EMPLOYEEE_HAS_COMMISSION_NUMBER_SECOND' | translate)"
                  >{{ emp.commissions_number }}</span
                  >
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "ESTIMATED_COST" | translate }}: </span>
                  <span>{{ emp.estimated_cost ? emp.estimated_cost : "-" }} €</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "EFFECTIVE_COST" | translate }}: </span>
                  <span>{{ emp.real_cost ? emp.real_cost : "-" }} €</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "ESTIMATED_REVENUE" | translate }}: </span>
                  <span>{{ emp.estimated_revenue ? emp.estimated_revenue : "-" }} €</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "EFFECTIVE_REVENUE" | translate }}: </span>
                  <span>{{ emp.real_profit ? emp.real_profit : "-" }} €</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "EURO_MARGIN" | translate }}: </span>
                  <span>{{ emp.euro_margin ? emp.euro_margin : "-" }} €</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "PERCENTAGE_MARGIN" | translate }}: </span>
                  <span>{{ emp.percentage_margin ? emp.percentage_margin : "-" }} %</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="pt-2" [ngClass]="activeTab === 'economic' ? 'col-12' : 'd-none'">
          <div>
            <span class="font-weight-bold">{{ "TOTAL_ABBREVIATION" | translate }} {{ "ESTIMATED_COST" | translate }}: </span>
            <span class="font-weight-bold">{{ total_estimated_cost }} €</span>
          </div>
          <div>
            <span class="font-weight-bold">{{ "TOTAL_ABBREVIATION" | translate }} {{ "EFFECTIVE_COST" | translate }}: </span>
            <span class="font-weight-bold">{{ total_real_cost }} €</span>
          </div>
          <div>
            <span class="font-weight-bold">{{ "TOTAL_ABBREVIATION" | translate }} {{ "ESTIMATED_REVENUE" | translate }}: </span>
            <span class="font-weight-bold">{{ total_estimated_revenue }} €</span>
          </div>
          <div>
            <span class="font-weight-bold">{{ "TOTAL_ABBREVIATION" | translate }} {{ "EFFECTIVE_REVENUE" | translate }}: </span>
            <span class="font-weight-bold">{{ total_real_profit }} €</span>
          </div>
          <div>
            <span class="font-weight-bold">{{ "TOTAL_ABBREVIATION" | translate }} {{ "EURO_MARGIN" | translate }}: </span>
            <span class="font-weight-bold">{{ total_margin_euro }} €</span>
          </div>
          <div>
            <span class="font-weight-bold">{{ "TOTAL_ABBREVIATION" | translate }} {{ "PERCENTAGE_MARGIN" | translate }}: </span>
            <span class="font-weight-bold">{{ total_margin_percentage }} %</span>
          </div>
          <div>
            <span class="font-weight-bold">{{ "TOTAL_ABBREVIATION" | translate }} {{ "PROVIDER_COST" | translate }}: </span>
            <span class="font-weight-bold">{{ total_provider_cost }} €</span>
          </div>
        </div>
      </div>
    </section>

    <!--ECONOMIC GRAPH SECTION-->
    <section class="col-12 section" has_capability="show_commission_economics" *ngIf="economicList && economicList.length > 0">
      <!--Desktop Economic-->
      <div class="card" [ngClass]="activeTab === 'economic-graph' ? 'active' : ''" *ngIf="_utilService.isDesktop">
        <!--TITLE-->
        <div class="card-title px-2 mb-0" (click)="changeTab('economic-graph')">
          <h3>{{ "ECONOMIC_GRAPH" | translate }}</h3>
        </div>
        <div class="card-body p-0 pt-1" *ngIf="activeTab === 'economic-graph'">
          <div class="col-12 text-right">
            <label>{{ "FILTER_BY_YEAR" | translate }}:</label>
            <select class="form-control d-inline-block w-fit ml-1 pr-4" [(ngModel)]="filterAnalyticsYear" (change)="loadCommission()">
              <option *ngFor="let year of analyticsYears" [selected]="year === filterAnalyticsYear" [value]="year">{{ year }}</option>
            </select>
          </div>
          <div class="col-12">
            <app-economic-graph></app-economic-graph>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>

<!-- Modal Detail Order -->
<ng-template #detailOrder let-modal>
  <form [formGroup]="formGroupOrder">
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modalClose()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <div class="d-flex align-items-center mb-1">
        <h3 class="mb-0 mr-075" *ngIf="selectedOrder">{{ "DETAIL_ROUND" | translate }} {{ selectedOrder?.progressive_id ? selectedOrder.progressive_id : null }}</h3>
        <h3 class="mb-0 mr-075" *ngIf="!selectedOrder">{{ "DETAIL_NEW_ROUND" | translate }}</h3>
        <span class="badge badge-pill badge-{{ selectedOrder?.status_order.color }}" *ngIf="editModeOrder">{{ selectedOrder?.status_order.label | translate }}</span>
      </div>
      <div class="row">
        <div class="form-group col-xl-3 col-12">
          <div class="d-flex justify-content-between">
            <label>{{ "DEAL" | translate }}<sup class="text-danger">*</sup></label>
            <a class="font-small-3" target="_blank" [routerLink]="'/dashboard/deals/edit/' + selectedDeal.id" *ngIf="selectedDeal">{{ "VIEW_DEAL" | translate }}</a>
          </div>
          <ng-select bindLabel="complete_name" bindValue="id" formControlName="deal_id" [readonly]="dealId || !!selectedOrder" [multiple]="false" [searchable]="true" (change)="selectDeal()" [clearable]="false"
                     [closeOnSelect]="true" [openOnEnter]="false" [virtualScroll]="true" [items]="dealsFilteredList"></ng-select>
        </div>
        <div class="form-group col-xl-3 col-12" *ngIf="selectedDeal">
          <label>{{ "FROM" | translate }}<sup class="text-danger">*</sup></label>
          <app-datepickr [isReadOnly]="selectedOrder?.status_order.status && selectedOrder?.status_order.status !== 0" [defaultDate]="formGroupOrder.value.from" [isInvalid]="!formGroupOrder.value.from && showErrors" (onSelect)="takeDate($event, 'from')"></app-datepickr>
          <div class="invalid-date" *ngIf="!formGroupOrder.value.from && showErrors">{{ "ERRORS.INSERT_FROM" | translate }}</div>
        </div>
        <div class="form-group col-xl-3 col-12" *ngIf="selectedDeal">
          <label>{{ "TO" | translate }}<sup class="text-danger">*</sup></label>
          <app-datepickr [isReadOnly]="(selectedOrder?.status_order.status && selectedOrder?.status_order.status === 2) || (selectedOrder?.status_order.status && selectedOrder?.status_order.status === 3)"
                         [defaultDate]="formGroupOrder.value.to" (onSelect)="takeDate($event, 'to')" [isInvalid]="!formGroupOrder.value.to && showErrors"></app-datepickr>
          <div class="invalid-date" *ngIf="!formGroupOrder.value.to && showErrors">{{ "ERRORS.INSERT_TO" | translate }}</div>
        </div>
        <div class="form-group col-xl-3 col-12" *ngIf="selectedDeal">
          <div class="d-flex justify-content-between">
            <label>{{ "PRODUCT_COMMISSION" | translate }}</label>
            <a *ngIf="selectedOrder && selectedOrder.product_commission_id" class="font-small-3" target="_blank" [routerLink]="'/dashboard/commissions/edit-product-commission/' + selectedOrder.product_commission_id">{{ "VIEW_COMMISSION" | translate }}</a>
          </div>
          <p class="mt-05 mb-0 font-small-3" *ngIf="productsCommissions.length < 1">{{ "NO_PRODUCT_COMMISSION_FOR_THIS_CLIENT" | translate }}</p>
          <ng-select *ngIf="productsCommissions.length > 0" bindLabel="complete_name" bindValue="id" formControlName="product_commission_id" (clear)="formGroupOrder.patchValue({ complete_name: null })" [multiple]="false" [searchable]="true"
                     [closeOnSelect]="true" [hideSelected]="true" [clearable]="true" [openOnEnter]="false" [virtualScroll]="false" [items]="productsCommissions"></ng-select>
        </div>
        <div class="form-group col-xl-{{ !formGroupDetail.value.detachment ? '6' : '4' }} col-12" *ngIf="selectedDeal">
          <label>{{ "BILLING_FREQUENCY" | translate }}<sup class="text-danger">*</sup></label>
          <ng-select [multiple]="false" [searchable]="true" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" [items]="billingFrequencyList" (change)="calculateTrancheNumberAndFrequency()"
                     class="{{ fieldHasErrors('billing_frequency') ? 'is-invalid' : '' }}" bindLabel="name" bindValue="id" formControlName="billing_frequency" [readonly]="selectedOrder?.status_order.status && selectedOrder?.status_order.status !== 0"></ng-select>
          <div class="invalid-feedback">{{ "ERRORS.INSERT_BILLING_FREQUENCY" | translate }}</div>
        </div>
        <div class="form-group col-xl-{{ !formGroupDetail.value.detachment ? '6' : '4' }} col-12" *ngIf="selectedDeal">
          <label>{{ "PAYAMENT_TERMS" | translate }}<sup class="text-danger">*</sup></label>
          <ng-select [multiple]="false" [searchable]="true" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" [items]="paymentsTermsList" formControlName="payment_terms"
                     class="{{ fieldHasErrors('payment_terms') ? 'is-invalid' : '' }}" bindLabel="name" bindValue="id"
                     [readonly]="(selectedOrder?.status_order.status && selectedOrder?.status_order.status === 2) || (selectedOrder?.status_order.status && selectedOrder?.status_order.status === 3)"></ng-select>
          <div class="invalid-feedback">{{ "ERRORS.INSERT_PAYMENT_TERMS" | translate }}</div>
        </div>
        <div class="form-group col-xl-4 col-12" *ngIf="selectedDeal && formGroupDetail.value.detachment">
          <label>{{ "DETACHMENT_TYPE" | translate }}<sup class="text-danger">*</sup></label>
          <ng-select bindLabel="name" bindValue="name" formControlName="detachment_type" [multiple]="false" [searchable]="true" [closeOnSelect]="true"
                     [readonly]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" [items]="detachmentTypes"></ng-select>
          <div class="font-error" *ngIf="showErrors && !formGroupOrder.value.detachment_type">{{ "ERRORS.INSERT_DETACHMENT_TYPE" | translate }}</div>
        </div>
        <div class="form-group col-xl-6" *ngIf="selectedDeal">
          <label>{{ "INVOICE_TYPE" | translate }}<sup class="text-danger">*</sup></label>
          <ng-select [multiple]="false" [searchable]="true" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" bindLabel="name" bindValue="id"
                     class="{{ fieldHasErrors('invoice_type') ? 'is-invalid' : '' }}" formControlName="invoice_type" [items]="invoiceTypeList"
                     [readonly]="(selectedOrder?.status_order.status && selectedOrder?.status_order.status === 2) || (selectedOrder?.status_order.status && selectedOrder?.status_order.status === 3)"
          ></ng-select>
          <div class="invalid-feedback">{{ "ERRORS.INSERT_INVOICE_TYPE" | translate }}</div>
        </div>
        <div class="form-group col-xl-6" *ngIf="selectedDeal">
          <label>{{ "PAYMENT_MEASURE_UNIT" | translate }}<sup class="text-danger">*</sup></label>
          <ng-select [multiple]="false" [searchable]="true" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" bindLabel="name" bindValue="id"
                     class="{{ fieldHasErrors('payment_measure_unit') ? 'is-invalid' : '' }}" formControlName="payment_measure_unit" [items]="paymentMeasureUnitList"
                     [readonly]="(selectedOrder?.status_order.status && selectedOrder?.status_order.status === 2) || (selectedOrder?.status_order.status && selectedOrder?.status_order.status === 3)"
          ></ng-select>
          <div class="invalid-feedback">{{ "ERRORS.INSERT_PAYMENT_MEASURE_UNIT" | translate }}</div>
        </div>
        <div class="form-group ml-1 custom-control custom-control-primary custom-switch" *ngIf="selectedDeal" [ngClass.sm]="'col-12 ml-2 mb-1'">
          <small class="mr-025">{{ "CUSTOMER_APPROVAL" | translate }}</small>
          <input type="checkbox" class="custom-control-input" id="customerApproval" formControlName="client_approval"
                 (click)="((selectedOrder?.status_order.status && selectedOrder?.status_order.status === 2) || (selectedOrder?.status_order.status && selectedOrder?.status_order.status === 3) ? false : null)" />
          <label class="custom-control-label" for="customerApproval"> </label>
        </div>
      </div>
      <div class="row mt-1" *ngIf="selectedDeal">
        <div class="col-12 mb-1">
          <h3 class="mb-0">{{ "ORDER" | translate }}</h3>
          <span class="text-primary cursor-pointer font-small-3" *ngIf="selectedDeal && !editModeOrder && orderList && orderList.length > 0 && !isCopingPrevOrderDetail" (click)="copyPrevOrderDetails()">{{ "COPY_FROM_PREV_ORDER" | translate }}</span>
        </div>
        <div class="form-group col-xl-3 col-12" *ngIf="selectedDeal">
          <div class="d-flex justify-content-between">
            <label>{{ "ORDER_NUMBER" | translate }}</label>
            <small class="text-primary cursor-pointer" (click)="modalOpen(addNewOrder, null)" *ngIf="selectedOrder && selectedOrder.order_number">{{ "ADD_ORDER" | translate }}</small>
          </div>
          <input formControlName="order_number" type="text" maxlength="100" class="form-control" />
        </div>
        <div class="form-group col-xl-2 col-12" *ngIf="selectedDeal">
          <label>{{ "ORDER_DATE" | translate }}</label>
          <app-datepickr id="order_date" [defaultDate]="formGroupOrder.value.order_date" (onSelect)="takeDate($event, 'order_date')"></app-datepickr>
        </div>
        <div class="form-group col-xl-3 col-12" *ngIf="selectedDeal">
          <label>{{ "TYPE_ORDER" | translate }}</label>
          <ng-select [ngModelOptions]="{ standalone: true }" (change)="changeTypeDeal()" [(ngModel)]="typeDeal" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" [readonly]="editModeOrder">
            <ng-option value="Task">{{ "TASK" | translate }}</ng-option>
            <ng-option value="Time Material">{{ "TIME_MATERIAL" | translate }}</ng-option>
          </ng-select>
        </div>
        <div class="form-group col-xl-2 col-12" *ngIf="selectedDeal">
          <div class="d-flex flex-sm-column flex-md-row justify-content-md-between align-items-md-center">
            <label>{{ "CAPACITY_ORDER" | translate }}<sup class="text-danger">*</sup></label>
            <label class="text-danger font-small-2" *ngIf="selectedDeal?.deal_document?.table[0]?.total_discounted_deal && selectedDeal?.deal_document?.table[0]?.total_discounted_deal !== selectedDeal?.deal_document?.table[0]?.total_deal">
              {{ "DISCOUNT_PROPOSED_TO_CUSTOMER" | translate }}: {{ selectedDeal?.deal_document?.table[0]?.total_discounted_deal }} € {{ "NOT_DISCOUNTED" | translate }}:
              {{ selectedDeal?.deal_document?.table[0]?.total_deal }} €
            </label>
          </div>
          <input (change)="formatMoneyValue('capacity')" formControlName="capacity" type="text" class="form-control {{ fieldHasErrors('capacity') ? 'is-invalid' : '' }}" />
          <div class="invalid-feedback">{{ "ERRORS.INSERT_CAPACITY" | translate }}</div>
        </div>
        <div class="form-group col-xl-2 col-12" *ngIf="selectedDeal">
          <label>{{ "RESIDUE_ORDER" | translate }}<sup class="text-danger">*</sup></label>
          <input [value]="formGroupOrder.value.residue" type="text" class="form-control" readonly />
        </div>
        <div class="form-group col-xl-6 col-12" *ngIf="selectedDeal">
          <label>{{ "CIG_CODE" | translate }}</label>
          <input formControlName="order_cig" maxlength="10" type="text" class="form-control {{ fieldHasErrors('order_cig') ? 'is-invalid' : '' }}" />
          <div class="invalid-feedback" *ngIf="formGroupOrder.controls?.order_cig?.errors?.maxlength">
            {{ "ERRORS.CIG_MAX_LENGTH" | translate }}
          </div>
        </div>
        <div class="form-group col-xl-6 col-12" *ngIf="selectedDeal">
          <label>{{ "CUP_CODE" | translate }}</label>
          <input formControlName="order_cup" maxlength="15" type="text" class="form-control {{ fieldHasErrors('order_cup') ? 'is-invalid' : '' }}" />
          <div class="invalid-feedback" *ngIf="formGroupOrder.controls?.order_cup?.errors?.maxlength">{{ "ERRORS.CUP_MAX_LENGTH" | translate }}</div>
        </div>
        <div class="form-group col-12" *ngIf="selectedDeal">
          <label>{{ "ORDER_DESCRIPTION" | translate }}</label>
          <textarea formControlName="order_description" class="form-control {{ fieldHasErrors('order_description') ? 'is-invalid' : '' }}"></textarea>
          <div class="invalid-feedback" *ngIf="formGroupOrder.controls?.order_description?.errors?.maxlength">
            {{ "ERRORS.DESCRIPTION_MAX_LENGTH" | translate }}
          </div>
        </div>
        <div class="col-12 section-secondary-order-title cursor-pointer d-flex align-items-center mt-2" (click)="openSecondaryOrders = !openSecondaryOrders"
             *ngIf="selectedDeal && selectedOrder && selectedOrder.order_children && selectedOrder && selectedOrder.order_children.length > 0">
          <h3 class="mr-1 mb-0">{{ (selectedOrder.order_children.length > 1 ? "SECONDARY_ORDERS" : "SECONDARY_ORDER") | translate }} ({{ selectedOrder.order_children.length }})</h3>
          <span class="text-primary" *ngIf="!openSecondaryOrders"><i [data-feather]="'eye'" size="20"></i></span>
          <span class="text-primary" *ngIf="openSecondaryOrders"><i [data-feather]="'eye-off'" size="20"></i></span>
        </div>
        <div id="section-secondary-orders" class="w-100 mb-2" *ngIf="selectedDeal && selectedOrder && selectedOrder.order_children && selectedOrder && selectedOrder.order_children.length > 0">
          <div class="col-12 border-bottom py-2" [ngClass]="openSecondaryOrders ? 'card-open' : 'd-none'" *ngFor="let childOrder of selectedOrder.order_children; let i = index">
            <div class="row">
              <div class="form-group col-xl-3 col-12">
                <div class="d-flex align-items-center">
                  <p class="text-primary font-medium-2 font-weight-bold text-center mb-0 mr-2">{{ i + 1 }}</p>
                  <div>
                    <label>{{ "ORDER_NUMBER" | translate }}:</label>
                    <div class="text-break-line-1" [ngbTooltip]="childOrder.order_description" placement="bottom">{{ childOrder.order_number }}</div>
                  </div>
                </div>
              </div>
              <div class="form-group col-xl-1 col-12">
                <label>{{ "ORDER_DATE" | translate }}:</label>
                <div>{{ childOrder.order_date | date: 'dd/MM/yyyy' }}</div>
              </div>
              <div class="form-group col-xl-1 col-12">
                <label>{{ "TYPE_ORDER" | translate }}:</label>
                <div>{{ childOrder.order_type }}</div>
              </div>
              <div class="form-group col-xl-1 col-12">
                <label>{{ "CIG_CODE" | translate }}:</label>
                <div>{{ childOrder.order_cig }}</div>
              </div>
              <div class="form-group col-xl-1 col-12">
                <label>{{ "CUP_CODE" | translate }}:</label>
                <div>{{ childOrder.order_cup }}</div>
              </div>
              <div class="form-group col-xl-2">
                <label>{{ "DOCUMENT_ORDER" | translate }}:</label>
                <div class="d-flex align-items-center" *ngIf="childOrder.file_url">
                  <span class="badge badge-light-success cursor-pointer px-1 pt-05 pb-05 mr-025" (click)="_utilService.getFile(childOrder.file_url)" [ngbTooltip]="'VIEW' | translate">
                    <span class="mr-025" [data-feather]="'file-text'" size="20"></span>
                    <span class="font-small-4 font-weight-bold">{{ 'ATTACHMENT_FOR_ORDER' | translate }} {{ childOrder.id }}</span>
                  </span>
                  <button type="button" class="btn border-0 px-0 text-danger" [ngbTooltip]="'DELETE' | translate" (click)="deleteChildAttachment(childOrder.id)">
                    <span [data-feather]="'trash-2'" size="16"></span>
                  </button>
                </div>
                <div *ngIf="!childOrder.file_url || childOrder.file_url.length < 1" class="font-small-3">{{ 'NO_DOCUMENT_ATTACHED' | translate }}</div>
              </div>
              <div class="form-group col-xl-1 pr-0 col-12 text-right">
                <label>{{ "CAPACITY_ORDER" | translate }}:</label>
                <div>{{ childOrder.order_capacity | currency: 'EUR' }}</div>
              </div>
              <div class="form-group col-xl-1 pr-0 col-12 text-right">
                <label>{{ "RESIDUE_ORDER" | translate }}:</label>
                <div>{{ childOrder.order_residue | currency: 'EUR' }}</div>
              </div>
              <div class="col-md-1 text-right">
                <button class="d-inline-block bg-transparent border-0 text-secondary" has_capability="edit_order" (click)="openModalEditChildOrder(addNewOrder, childOrder)">
                  <i [data-feather]="'edit-2'" size="19"></i>
                </button>
                <button class="d-inline-block bg-transparent border-0 text-danger remove-item" has_capability="delete_order" (click)="deleteChildOrder(childOrder.id)">
                  <i [data-feather]="'trash-2'" size="19"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group col-xl-2 offset-xl-{{!openSecondaryOrders ? 9 : 8}} col-12 text-right" *ngIf="selectedOrder && selectedOrder.total_capacity">
          <label class="font-weight-bold">{{ "TOTAL_CAPACITY" | translate }}</label>
          <div class="font-weight-bold">{{ selectedOrder.total_capacity | currency: 'EUR' }}</div>
        </div>
        <div class="form-group col-xl-1 col-12 text-right" *ngIf="selectedOrder && selectedOrder.total_residue">
          <label class="font-weight-bold">{{ "TOTAL_RESIDUE" | translate }}</label>
          <div class="font-weight-bold">{{ selectedOrder.total_residue | currency: 'EUR' }}</div>
        </div>
      </div>
      <div id="employees-details" class="row mt-1" *ngIf="selectedDeal">
        <div class="col-12">
          <h3>{{ "EMPLOYEES_DETAIL" | translate }}</h3>
        </div>
        <div class="form-group col-xl-6 col-12 d-flex align-items-center">
          <div class="cursor-pointer mt-1 mr-075" *ngIf="editModeOrder && ((taskEmployee && taskEmployee.length > 0) || (timeMaterialEmployee && timeMaterialEmployee.length > 0))">
            <span class="text-primary" [ngbTooltip]="'OPEN_DETAIL_EMPLOYEE' | translate" (click)="openDetailEmployee = !openDetailEmployee" *ngIf="!openDetailEmployee"><i [data-feather]="'eye'" size="20"></i></span>
            <span class="text-primary" [ngbTooltip]="'CLOSE_DETAIL_EMPLOYEE' | translate" (click)="openDetailEmployee = !openDetailEmployee" *ngIf="openDetailEmployee"><i [data-feather]="'eye-off'" size="20"></i></span>
          </div>
          <div class="d-flex flex-column w-100">
            <label>{{ "TITLES.USERS_TYPES.employee" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select class="{{ fieldHasErrors('employees_hash') ? 'is-invalid' : '' }}" (change)="typeDeal && typeDeal === 'Time Material' ? manageTimeMaterialRow() : manageTaskRow()"
                       [hideSelected]="true" [multiple]="true" [searchable]="true" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="false" formControlName="employees_hash"
                       [items]="selectedOrder?.status_order.status && selectedOrder?.status_order.status !== 0 ? employeesListWithExEmployee : employeesList"
                       [readonly]="selectedOrder?.status_order.status && selectedOrder?.status_order.status !== 0" bindLabel="complete_name" bindValue="hash"></ng-select>
          </div>
          <div class="invalid-feedback">{{ "ERRORS.EMPLOYEES_REQUIRED" | translate }}</div>
        </div>
        <div class="form-group col-xl-3 col-12" *ngIf="typeDeal && typeDeal === 'Task'">
          <label>{{ "TRANCHE_NUMBER" | translate }}<sup class="text-danger">*</sup></label>
          <input formControlName="tranche_number" [readonly]="true" type="number" class="form-control {{ fieldHasErrors('tranche_number') ? 'is-invalid' : '' }}" />
          <div class="invalid-feedback">{{ "ERRORS.INSERT_TRANCHE_NUMBER" | translate }}</div>
        </div>
        <div class="form-group col-xl-3 col-12" *ngIf="typeDeal && typeDeal === 'Task'">
          <label>{{ "TRANCHE_IMPORT" | translate }}<sup class="text-danger">*</sup></label>
          <input (change)="formatMoneyValue('tranche_import')" formControlName="tranche_import" type="text" [readonly]="selectedOrder?.status_order.status && selectedOrder?.status_order.status !== 0"
                 class="form-control {{ fieldHasErrors('tranche_import') ? 'is-invalid' : '' }}" />
          <div class="invalid-feedback">{{ "ERRORS.INSERT_TRANCHE_IMPORT" | translate }}</div>
        </div>
        <div *ngIf="openDetailEmployee" class="col-12" [@inOutAnimation]>
          <div class="row">
            <div class="col-12" *ngIf="typeDeal && typeDeal === 'Task'">
              <div class="row" *ngFor="let row of taskEmployee; let i = index">
                <div class="form-group col-xl-3 col-12">
                  <label>{{ "TITLES.USERS_TYPES_SINGULAR.employee" | translate }}<sup class="text-danger">*</sup></label>
                  <ng-select bindLabel="complete_name" bindValue="hash" [(ngModel)]="row.employee_hash" [readonly]="true" [multiple]="false" [searchable]="true" [closeOnSelect]="true"
                             [ngModelOptions]="{ standalone: true }" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" [items]="employeesListWithExEmployee"></ng-select>
                </div>
                <div class="form-group col-xl-2 col-12">
                  <label>{{ "MONTH_ACTIVITY" | translate }}<sup class="text-danger">*</sup></label>
                  <input [(ngModel)]="row.months" type="text" class="form-control" [readonly]="true" [ngModelOptions]="{ standalone: true }" />
                </div>
                <div class="form-group col-xl-2 col-12">
                  <label>{{ "MONTHLY_IMPORT" | translate }}<sup class="text-danger">*</sup></label>
                  <input (change)="formatMonthlyImport(i)" [(ngModel)]="row.monthly_import" [readonly]="selectedOrder?.status_order.status && selectedOrder?.status_order.status !== 0" type="text"
                         class="form-control" [ngModelOptions]="{ standalone: true }" />
                </div>
                <div class="form-group col-xl-2 col-12">
                  <label>{{ "TRANCHE_NUMBER" | translate }}<sup class="text-danger">*</sup></label>
                  <input [(ngModel)]="formGroupOrder.value.tranche_number" type="text" class="form-control" [readonly]="true" [ngModelOptions]="{ standalone: true }" />
                </div>
                <div class="form-group col-xl-3 col-12">
                  <label>{{ "TRANCHE_IMPORT_EMPLOYEE" | translate }}<sup class="text-danger">*</sup></label>
                  <input [(ngModel)]="row.tranche_single_import" [readonly]="true" type="text" class="form-control" [ngModelOptions]="{ standalone: true }" />
                </div>
              </div>
            </div>
            <!--For timeMaterial for each employee we have days_number and daily_rate-->
            <div class="col-12" *ngIf="typeDeal && typeDeal === 'Time Material'">
              <div class="row" *ngFor="let row of timeMaterialEmployee; let i = index">
                <div class="form-group col-xl-4 col-12">
                  <label>{{ "TITLES.USERS_TYPES_SINGULAR.employee" | translate }}<sup class="text-danger">*</sup></label>
                  <ng-select bindLabel="complete_name" bindValue="hash" [(ngModel)]="row.employee_hash" [readonly]="true" [multiple]="false" [searchable]="true"
                             [closeOnSelect]="true" [ngModelOptions]="{ standalone: true }" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" [items]="employeesListWithExEmployee"></ng-select>
                </div>
                <div class="form-group col-xl-4 col-12">
                  <label>{{ "DAYS_NUMBER" | translate }}<sup class="text-danger">*</sup></label>
                  <input (change)="calculateCapacityTimeMaterial()" [(ngModel)]="row.effort" type="number" class="form-control" [ngModelOptions]="{ standalone: true }"
                         [readonly]="selectedOrder?.status_order.status && selectedOrder?.status_order.status !== 0" />
                </div>
                <div class="form-group col-xl-4 col-12">
                  <label>{{ "DAILY_RATE" | translate }}<sup class="text-danger">*</sup></label>
                  <input (change)="formatDailyRate(i); calculateCapacityTimeMaterial()" [(ngModel)]="row.daily_rate" type="text" class="form-control" [ngModelOptions]="{ standalone: true }"
                         [readonly]="selectedOrder?.status_order.status && selectedOrder?.status_order.status !== 0" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group col-12" *ngIf="selectedDeal">
          <label>{{ "ROUND_DESCRIPTION" | translate }}</label>
          <textarea formControlName="description" type="text" class="form-control {{ fieldHasErrors('description') ? 'is-invalid' : '' }}"></textarea>
          <div class="invalid-feedback" *ngIf="formGroupOrder.controls?.description?.errors?.maxlength"> {{ "ERRORS.DESCRIPTION_MAX_LENGTH" | translate }}</div>
        </div>
      </div>
      <!--File Section-->
      <div class="row mt-1" *ngIf="selectedDeal">
        <div class="col-xl-6 col-12" ngClass.xl="border-right" ngClass.md="mb-1" ngClass.sm="mb-1">
          <h3>{{ "DOCUMENT_ORDER" | translate }}</h3>
          <div class="row" *ngIf="order_document">
            <div class="col-12 mb-05">
              <span class="badge badge-light-success cursor-pointer px-1 pt-05 pb-05 mr-025" [ngbTooltip]="'VIEW' | translate" (click)="_utilService.getFile(order_document)">
                <span class="mr-025" [data-feather]="'file-text'" size="20"></span>
                <span class="font-small-4 font-weight-bold">{{ order_document_name }}</span>
              </span>
              <button type="button" class="btn border-0 px-0 text-danger" [ngbTooltip]="'DELETE' | translate" (click)="deleteDocument()">
                <span [data-feather]="'trash-2'" size="16"></span>
              </button>
            </div>
          </div>
          <div class="row" *ngIf="!order_document">
            <div class="col-10 mb-05">
              <div class="form-group custom-control custom-control-primary custom-switch" [ngClass.sm]="'col-12 ml-2 mb-1'"
                   *ngIf="selectedDeal && !editModeOrder && orderList && orderList.length > 0 && orderList[orderList.length - 1].file_url && (!files_list || files_list.length < 1)">
                <small class="mr-025">{{ "UPLOAD_DOCUMENT_FROM_PREV_ORDER" | translate }}</small>
                <input type="checkbox" class="custom-control-input" id="copyDocumentOrder" [checked]="isCopingPrevDocument" (click)="toggleCheckCopyDocument()" />
                <label class="custom-control-label" for="copyDocumentOrder"> </label>
              </div>
              <div *ngIf="!isCopingPrevDocument">{{ "NO_ONE_DOCUMENT_UPLOADED" | translate }}</div>
            </div>
          </div>
          <div class="row pt-1" *ngIf="(selectedOrder?.status_order !== 2 || !editModeOrder) && !isCopingPrevDocument">
            <div class="col-xl-6 col-12">
              <div id="file-uploader" class="custom-file">
                <input class="custom-file-input" type="file" lang="it" id="file" [multiple]="false" (change)="addFileToList($any($event).target.files)" accept="application/pdf" />
                <label class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
              </div>
            </div>
            <div class="col-xl-6 col-12" *ngIf="files_list_obj.length > 0">
              <button class="btn btn-outline-danger" (click)="resetFilesList()">{{ "RESET" | translate }}</button>
            </div>
          </div>
          <div class="row">
            <div class="col-12" *ngIf="isCopingPrevDocument">
              <span class="badge badge-light-success cursor-pointer px-1 pt-05 pb-05 mr-025" [ngbTooltip]="'VIEW' | translate">
                <span class="mr-025" [data-feather]="'file-text'" size="20"></span>
                <span class="font-small-4 font-weight-bold">{{ orderList[orderList.length - 1].file_url.split("/")[1] }}</span>
              </span>
              <button type="button" class="btn border-0 px-0 text-danger" [ngbTooltip]="'DELETE' | translate" (click)="isCopingPrevDocument = !isCopingPrevDocument">
                <span [data-feather]="'trash-2'" size="16"></span>
              </button>
            </div>
            <div class="col-11 mt-3 border-top pt-1" *ngIf="files_list_obj.length > 0">
              <div *ngFor="let file of files_list_obj; let i = index" class="d-flex border-bottom mb-1 pb-1">
                <div class="flex-basis-60 d-flex align-items-center">
                  <div class="mr-05 cursor-pointer" (click)="removeFileFromList(i)" *ngIf="file.status === 0">
                    <i [data-feather]="'x'" class="text-danger" size="18"></i>
                  </div>
                  <div class="mt-025">{{ file.name }}</div>
                </div>
                <div class="flex-basis-20 text-right">{{ file.size }}</div>
              </div>
              <div>{{ "TOTAL" | translate }}: {{ files_list_obj.length }}</div>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-12">
          <h3>{{ "ATTACHMENTS_ORDER" | translate }}</h3>
          <div class="row" *ngIf="selectedOrder && selectedOrder.order_attachments && selectedOrder.order_attachments.length > 0">
            <div class="col-12 d-flex align-items-center" *ngFor="let file of selectedOrder.order_attachments">
              <span class="badge badge-light-success cursor-pointer mr-025" [ngbTooltip]="'VIEW' | translate" (click)="_utilService.getFile(file.url)">
                <span class="mr-025" [data-feather]="'file-text'" size="16"></span>{{ file?.filename }}</span>
              <button type="button" class="btn border-0 px-0 text-danger" [ngbTooltip]="'DELETE' | translate" (click)="deleteAttachment(file.id)">
                <span [data-feather]="'trash-2'" size="16"></span>
              </button>
            </div>
          </div>
          <div class="row" *ngIf="!selectedOrder || !selectedOrder.order_attachments || (selectedOrder && selectedOrder.order_attachments && selectedOrder.order_attachments.length < 1)">
            <div class="col-10 d-flex justify-content-between align-items-center mb-05">
              <div>{{ "NO_ONE_DOCUMENT_UPLOADED" | translate }}</div>
            </div>
          </div>
          <div class="row" *ngIf="selectedOrder?.status_order !== 2 || !editModeOrder">
            <div class="col-xl-6 col-12">
              <div id="attachment-uploader" class="custom-file mt-1">
                <input class="custom-file-input" type="file" lang="it" id="attachment" [multiple]="true" (change)="addAttachmentToList($any($event).target.files)" accept="application/pdf" />
                <label class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mt-1">
              <div class="d-flex align-items-center justify-content-between">
                <div *ngIf="attachments_list_obj.length > 0">
                  <button class="btn btn-outline-danger" (click)="resetAttachmentsList()">{{ "RESET" | translate }}</button>
                </div>
              </div>
            </div>
            <div class="col-12 mt-3 border-top pt-1" *ngIf="attachments_list_obj.length > 0">
              <div *ngFor="let file of attachments_list_obj; let i = index" class="d-flex border-bottom mb-1 pb-1">
                <div class="flex-basis-60 d-flex align-items-center">
                  <div class="mr-05 cursor-pointer" (click)="removeAttachmentFromList(i)" *ngIf="file.status === 0">
                    <i [data-feather]="'x'" class="text-danger" size="18"></i>
                  </div>
                  <div class="mt-025">{{ file.name }}</div>
                </div>
                <div class="flex-basis-20 text-right">{{ file.size }}</div>
              </div>
              <div>{{ "TOTAL" | translate }}: {{ attachments_list_obj.length }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center" *ngIf="(!editModeOrder && selectedDeal) || (selectedOrder && selectedOrder?.status_order !== 2)">
      <button type="submit" class="btn btn-primary w-150" rippleEffect (click)="editModeOrder ? editOrder() : createOrder()">
        {{ "SAVE" | translate }}
      </button>
    </div>
  </form>
</ng-template>
<!-- / Modal Detail Order -->

<!-- note Close Commission Modal -->
<ng-template #closeCommissionModal let-modal>
  <div>
    <div class="modal-header">
      <div></div>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "INSERT_NOTE" | translate }}</h3>
      <div class="form-group mb-1">
        <label>{{ "NOTE" | translate }}<sup class="text-danger">*</sup></label>
        <textarea [(ngModel)]="closeMotivation" class="form-control" cols="45" rows="3"></textarea>
      </div>
      <div class="form-group">
        <label>{{ "FROM" | translate }}<sup class="text-danger">*</sup></label>
        <app-datepickr [defaultDate]="todayDate" (onSelect)="takeDate($event, 'close_date')"></app-datepickr>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button class="btn btn-outline-primary" (click)="modalClose()">{{ "BACK" | translate }}</button>
      <button [disabled]="!closeMotivation || closeMotivation.length < 5" (click)="closeCommission()" class="btn btn-primary w-150" rippleEffect>
        {{ "SEND" | translate }}
      </button>
    </div>
  </div>
</ng-template>
<!-- / note Close Commission Modal -->

<!-- Modale gestione conflitto date -->
<ng-template #roundConflictDecision let-modal>
  <div>
    <div class="modal-header">
      <div></div>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "ALERT.ALERT_TITLE" | translate }}</h3>
      <div *ngIf="conflictRoundDetail && !conflictRoundDetail.conflictRound.detachment_type">
        <p>{{ "ALERT.ALREADY_PRESENT_A_ROUND" | translate }}</p>
        <p>{{ "ORIGINAL_CLOUSURE_ROUND" | translate }}: {{ conflictRoundDetail.originalEndDate | date: 'dd/MM/yyyy' }}</p>
        <p>{{ "NEW_CLOUSURE_ROUND" | translate }}: {{ conflictRoundDetail.newEndDate | date: 'dd/MM/yyyy' }}</p>
      </div>
      <p *ngIf="!!conflictRoundDetail && !!conflictRoundDetail.conflictRound.detachment_type">{{ "ALERT.ALREADY_PRESENT_A_ROUND_DETACHMENT" | translate }}</p>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button *ngIf="!!conflictRoundDetail" class="btn btn-outline-primary" (click)="modal.dismiss('Cross click')">
        {{ !conflictRoundDetail.conflictRound.detachment_type ? ("CANCEL" | translate) : ("ALERT.BTN_CLOSE" | translate) }}
      </button>
      <button *ngIf="!!conflictRoundDetail && !conflictRoundDetail.conflictRound.detachment_type" (click)="changeEndDateRoundBefore(); modal.dismiss('Cross click')" class="btn btn-primary w-150" rippleEffect>
        {{ "ACCEPT_NEW_DATE" | translate }}
      </button>
    </div>
  </div>
</ng-template>
<!-- /Modale gestione conflitto date -->

<!-- Modale aggiungi ordine figlio -->
<ng-template #addNewOrder let-modal>
  <div>
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modalCloseNewOrder()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0" [formGroup]="formNewOrder">
      <h3>{{ !editModeOrderChild ? ("ADD_ORDER" | translate) : ("EDIT_ORDER" | translate) }}</h3>
      <div class="row">
        <div class="form-group col-xl-4">
          <label>{{ "ORDER_NUMBER" | translate }}<sup class="text-danger">*</sup></label>
          <input formControlName="order_number" type="text" maxlength="100" class="form-control {{ fieldHasErrorsNewOrder('order_number') ? 'is-invalid' : '' }}" />
        </div>
        <div class="form-group col-xl-4">
          <label>{{ "ORDER_DATE" | translate }}<sup class="text-danger">*</sup></label>
          <app-datepickr [defaultDate]="formNewOrder.value.order_date" (onSelect)="takeDate($event, 'new_order_date')" [isInvalid]="!formNewOrder.value.order_date && showErrors"></app-datepickr>
        </div>
        <div class="form-group col-xl-4">
          <label>{{ "TYPE_ORDER" | translate }}<sup class="text-danger">*</sup></label>
          <ng-select class="{{ fieldHasErrorsNewOrder('order_type') ? 'is-invalid' : '' }}" formControlName="order_type" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true">
            <ng-option value="Task">{{ "TASK" | translate }}</ng-option>
            <ng-option value="Time Material">{{ "TIME_MATERIAL" | translate }}</ng-option>
          </ng-select>
        </div>
        <div class="form-group col-xl-12">
          <label>{{ "ORDER_DESCRIPTION" | translate }}<sup class="text-danger">*</sup></label>
          <textarea formControlName="order_description" class="form-control {{ fieldHasErrorsNewOrder('order_description') ? 'is-invalid' : '' }}"></textarea>
          <div class="invalid-feedback" *ngIf="formNewOrder.controls?.order_description?.errors?.maxlength">{{ "ERRORS.DESCRIPTION_MAX_LENGTH" | translate }}</div>
        </div>
        <div class="form-group col-xl-4 col-12">
          <label>{{ "CIG_CODE" | translate }}</label>
          <input formControlName="order_cig" maxlength="10" type="text" class="form-control {{ fieldHasErrorsNewOrder('order_cig') ? 'is-invalid' : '' }}" />
          <div class="invalid-feedback" *ngIf="formNewOrder.controls?.order_cig?.errors?.maxlength">{{ "ERRORS.CIG_MAX_LENGTH" | translate }}</div>
        </div>
        <div class="form-group col-xl-4 col-12">
          <label>{{ "CUP_CODE" | translate }}</label>
          <input formControlName="order_cup" maxlength="15" type="text" class="form-control {{ fieldHasErrorsNewOrder('order_cup') ? 'is-invalid' : '' }}" />
          <div class="invalid-feedback" *ngIf="formNewOrder.controls?.order_cup?.errors?.maxlength">{{ "ERRORS.CUP_MAX_LENGTH" | translate }}</div>
        </div>

        <div class="form-group col-xl-4">
          <label>{{ "BILLING_FREQUENCY" | translate }}<sup class="text-danger">*</sup></label>
          <ng-select [multiple]="false" [searchable]="true" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" [items]="billingFrequencyList"
                     class="{{ fieldHasErrorsNewOrder('billing_frequency') ? 'is-invalid' : '' }}" bindLabel="name" bindValue="id" formControlName="billing_frequency"></ng-select>
          <div class="invalid-feedback">{{ "ERRORS.INSERT_BILLING_FREQUENCY" | translate }}</div>
        </div>
        <div class="form-group col-xl-4">
          <label>{{ "PAYAMENT_TERMS" | translate }}<sup class="text-danger">*</sup></label>
          <ng-select [multiple]="false" [searchable]="true" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" [items]="paymentsTermsList"
                     class="{{ fieldHasErrorsNewOrder('payment_terms') ? 'is-invalid' : '' }}" bindLabel="name" bindValue="id" formControlName="payment_terms"></ng-select>
          <div class="invalid-feedback">{{ "ERRORS.INSERT_PAYMENT_TERMS" | translate }}</div>
        </div>
        <div class="form-group col-xl-4">
          <label>{{ "INVOICE_TYPE" | translate }}<sup class="text-danger">*</sup></label>
          <ng-select [multiple]="false" [searchable]="true" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" [items]="invoiceTypeList"
                     class="{{ fieldHasErrorsNewOrder('invoice_type') ? 'is-invalid' : '' }}" bindLabel="name" bindValue="id" formControlName="invoice_type"></ng-select>
          <div class="invalid-feedback">{{ "ERRORS.INSERT_INVOICE_TYPE" | translate }}</div>
        </div>
        <div class="form-group col-xl-4">
          <label>{{ "PAYMENT_MEASURE_UNIT" | translate }}<sup class="text-danger">*</sup></label>
          <ng-select [multiple]="false" [searchable]="true" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" [items]="paymentMeasureUnitList"
                     class="{{ fieldHasErrorsNewOrder('payment_measure_unit') ? 'is-invalid' : '' }}" bindLabel="name" bindValue="id" formControlName="payment_measure_unit"></ng-select>
          <div class="invalid-feedback">{{ "ERRORS.INSERT_PAYMENT_MEASURE_UNIT" | translate }}</div>
        </div>
        <div class="form-group col-xl-4">
          <div class="d-flex flex-sm-column flex-md-row justify-content-md-between align-items-md-center">
            <label>{{ "CAPACITY_ORDER" | translate }}<sup class="text-danger">*</sup></label>
          </div>
          <input (change)="formatMoneyValue('new_capacity')" formControlName="order_capacity" type="text" class="form-control {{ fieldHasErrorsNewOrder('order_capacity') ? 'is-invalid' : '' }}" />
          <div class="invalid-feedback">{{ "ERRORS.INSERT_CAPACITY" | translate }}</div>
        </div>
        <div class="form-group col-xl-4 col-12">
          <label>{{ "RESIDUE_ORDER" | translate }}</label>
          <input formControlName="order_residue" readonly type="text" class="form-control" />
        </div>
        <div class="form-group col-xl-4 col-12">
          <label>{{ "DOCUMENT_ORDER" | translate }}</label>
          <div id="file-uploader-child-order" class="custom-file">
            <input class="custom-file-input" type="file" lang="it" id="file-child-order" (change)="addAttachmentToChildOrder($any($event).target.files[0])" accept="application/pdf" />
            <label class="custom-file-label">{{ !!childOrderFile ? childOrderFile.name : ("SELECT_FILE" | translate) }}</label>
          </div>
          <div *ngIf="editModeOrderChild && childOrderFile && !childOrderFile.name">
            <a class="font-small-3 text-primary d-inline-block mt-05" (click)="_utilService.getFile(childOrderFile)">{{ 'VIEW_FILE' | translate }}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button class="btn btn-outline-primary" (click)="modalCloseNewOrder()">{{ "CANCEL" | translate }}</button>
      <button (click)="!editModeOrderChild ? addNewChildOrder() : editChildOrder()" class="btn btn-primary w-150" rippleEffect>{{ "SAVE" | translate }}</button>
    </div>
  </div>
</ng-template>
<!-- / Modale aggiungi ordine -->

<!-- Close Round Modal -->
<ng-template #closeRoundModal let-modal>
  <div>
    <div class="modal-header">
      <div></div>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "CLOSE_ROUND" | translate }}</h3>
      <div class="form-group mb-1">
        <label>{{ "FROM" | translate }}<sup class="text-danger">*</sup></label>
        <app-datepickr [displayMonths]="1" [maxDate]="todayDate.format('YYYY-MM-DD')" [defaultDate]="closeRoundDate" (onSelect)="takeDate($event, 'closeRoundDate')" [isInvalid]="!closeRoundDate && showErrors"></app-datepickr>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button class="btn btn-outline-primary" (click)="modalClose()">{{ "BACK" | translate }}</button>
      <button [disabled]="!closeRoundDate" (click)="manageStatusOrder()" class="btn btn-primary w-150" rippleEffect>
        {{ "SEND" | translate }}
      </button>
    </div>
  </div>
</ng-template>
<!-- / Close Round Modal -->
